import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation(); // Get the current location

  const handleToggleSidebar = () => {
    // Your toggle sidebar logic here
    window.clickToggleSidebarIcon();
    console.log("Sidebar toggled!");
  };

  return (
    <div className="sidebar" id="main-sidebar" data-background-color="dark">
      <div className="sidebar-logo">
        <div className="logo-header" data-background-color="dark">
          <Link to="/dashboard" className="logo">
            <img
              src="/icon/sidebar-icon-white.png"
              alt="navbar brand"
              className="navbar-brand"
              loading="lazy"
              height="40"
            />
          </Link>
          <div
            className="nav-toggle cursor-pointer"
            onClick={handleToggleSidebar}
          >
            <button className="btn btn-toggle toggle-sidebar">
              <i className="gg-menu-right"></i>
            </button>
            <button className="btn btn-toggle sidenav-toggler">
              <i className="gg-menu-left"></i>
            </button>
          </div>
          <button className="topbar-toggler more">
            <i className="gg-more-vertical-alt"></i>
          </button>
        </div>
      </div>
      <div className="sidebar-wrapper scrollbar scrollbar-inner">
        <div className="sidebar-content">
          <ul className="nav nav-secondary">
            <li
              className={`nav-item ${
                location.pathname === "/user/dashboard" ? "active" : ""
              }`}
            >
              <Link to="/user/dashboard">
                <i className="fas fa-home"></i>
                <p>Dashboard</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/user/users" ? "active" : ""
              }`}
            >
              <Link to="/user/users">
                <i className="fas fa-user"></i>
                <p>Users</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/user/attendance" ? "active" : ""
              }`}
            >
              <Link to="/user/attendance">
                <i className="fas fa-user"></i>
                <p>Attendance</p>
              </Link>
            </li>

            {/* Add user tab */}
            {/* <li
              className={`nav-item ${
                location.pathname === "/user/create" ? "active" : ""
              }`}
            >
              <Link to="/user/create">
                <i className="fas fa-users"></i>
                <p>Students</p>
              </Link>
            </li> */}

            {/* Add Properties Tab */}
            <li
              className={`nav-item ${
                location.pathname === "/user/properties" ? "active" : ""
              }`}
            >
              <Link to="/user/properties">
                <i className="fas fa-home"></i>
                <p>Properties</p>
              </Link>
            </li>

            {/* Add Enquiry Tab */}
            <li
              className={`nav-item ${
                location.pathname === "/user/enquiry" ? "active" : ""
              }`}
            >
              <Link to="/user/enquiry">
                <i className="fas fa-question-circle"></i>
                <p>Enquiries</p>
              </Link>
            </li>
            {/* Add Leads Tab */}
            <li
              className={`nav-item ${
                location.pathname === "/user/leads" ? "active" : ""
              }`}
            >
              <Link to="/user/leads">
                <i className="fas fa-question-circle"></i>
                <p>Leads</p>
              </Link>
            </li>

            {/* Add Leads Tab */}
            <li
              className={`nav-item ${
                location.pathname === "/user/gallery" ? "active" : ""
              }`}
            >
              <Link to="/user/gallery">
                <i className="fas fa-question-circle"></i>
                <p>Gallery</p>
              </Link>
            </li>
            {/* Add Ammenitites Tab */}
            <li
              className={`nav-item ${
                location.pathname === "/user/amenities" ? "active" : ""
              }`}
            >
              <Link to="/user/amenities">
                <i className="fas fa-question-circle"></i>
                <p>Ammenities</p>
              </Link>
            </li>
            {/* Add Builder Tab */}
            <li
              className={`nav-item ${
                location.pathname === "/user/builder" ? "active" : ""
              }`}
            >
              <Link to="/user/builder">
                <i className="fas fa-question-circle"></i>
                <p>Builder</p>
              </Link>
            </li>

            <li
              className={`nav-item d-none ${
                location.pathname === "/user/playlists" ? "active" : ""
              }`}
            >
              <Link to="/user/events">
                <i className="fas fa-link"></i>
                <p>Integrations</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/user/blogs" ? "active" : ""
              }`}
            >
              <Link to="/user/blogs">
                <i className="fas fa-question-circle"></i>
                <p>Blogs</p>
              </Link>
            </li>

            {/* Add a property tour page */}
            <li
              className={`nav-item ${
                location.pathname === "/user/property-tours" ? "active" : ""
              }`}
            >
              <Link to="/user/property-tours">
                <i className="fas fa-video"></i>
                <p>Property Tours</p>
              </Link>
            </li>

            {/* Add a Task Assignment page */}
            <li
              className={`nav-item ${
                location.pathname === "/user/task-management" ? "active" : ""
              }`}
            >
              <Link to="/user/task-management">
                <i className="fas fa-tasks"></i>
                <p>Task Management</p>
              </Link>
            </li>

            {/* <li
              className={`nav-item ${
                location.pathname === "/user/account-settings" ? "active" : ""
              }`}
            >
              <Link to="/user/account-settings">
                <i className="fas fa-cog"></i>
                <p>Account Settings</p>
              </Link>
            </li> */}
            <li
              className={`nav-item d-none ${
                location.pathname === "/user/feedback" ? "active" : ""
              }`}
            >
              <Link to="/user/events">
                <i className="fas fa-comment"></i>
                <p>Support</p>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              <a href="/logout">
                <i className="fas fa-sign-out-alt"></i>
                <p>Logout</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
